import React from 'react';
import {
  BOOKING_GOLD,
  BOOKING_GOLD_RGBA,
  PACKAGE_CARD_BG,
  BOOKING_PACKAGES,
} from '../../constants/booking';

function PackageCard({ pkg, isSelected, onSelect }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(pkg)}
      style={{
        textAlign: 'left',
        padding: '1.25rem',
        borderRadius: '0.75rem',
        border: isSelected ? `2px solid ${BOOKING_GOLD}` : `1px solid ${BOOKING_GOLD}`,
        backgroundColor: isSelected ? `${BOOKING_GOLD_RGBA}, 0.12)` : PACKAGE_CARD_BG,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          fontSize: '0.75rem',
          fontWeight: '700',
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: BOOKING_GOLD,
          marginBottom: '0.4rem',
        }}
      >
        {pkg.name}
      </div>
      <div
        style={{
          fontSize: '0.9375rem',
          fontWeight: '600',
          color: '#F5F0E8',
          marginBottom: '0.65rem',
          lineHeight: 1.3,
        }}
      >
        {pkg.hook}
      </div>
      <div
        style={{
          fontSize: '1.75rem',
          fontWeight: '700',
          color: '#ffffff',
          lineHeight: 1.2,
          marginBottom: '0.2rem',
        }}
      >
        ${pkg.basePrice.toLocaleString()}
      </div>
      <div style={{ fontSize: '0.8125rem', color: BOOKING_GOLD, marginBottom: '0.75rem' }}>
        {pkg.priceDescriptor || `${pkg.fixedDuration}-hour event`}
      </div>
      <p
        style={{
          fontSize: '0.8125rem',
          color: 'rgba(245, 240, 232, 0.65)',
          margin: 0,
          lineHeight: 1.45,
        }}
      >
        {pkg.description}
      </p>
    </button>
  );
}

export default function PackageSelector({ packages, selectedPackage, onSelect, isMobile }) {
  const visiblePackages = packages?.length ? packages : BOOKING_PACKAGES;

  return (
    <div className="dd-booking-packages">
      <h2
        style={{
          fontSize: isMobile ? '1.5rem' : '1.75rem',
          fontWeight: '700',
          color: BOOKING_GOLD,
          marginBottom: '0.65rem',
          textAlign: 'center',
        }}
      >
        Choose Your Experience
      </h2>

      <p
        style={{
          textAlign: 'center',
          color: 'rgba(245, 240, 232, 0.65)',
          fontSize: '0.9375rem',
          margin: '0 0 1.5rem',
          lineHeight: 1.55,
        }}
      >
        One premium mobile golf setup. Three ways to play.
      </p>

      <div
        className="dd-package-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : `repeat(${Math.min(visiblePackages.length, 3)}, 1fr)`,
          gap: '1rem',
          animation: 'dd-pricing-fade 0.28s ease',
        }}
      >
        {visiblePackages.map((pkg) => (
          <PackageCard
            key={pkg.id}
            pkg={pkg}
            isSelected={selectedPackage?.id === pkg.id}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
}
